(function () {
  function copyURI(evt) {
    evt.preventDefault();
    navigator.clipboard
      .writeText(evt.target.href || window.location.href)
      .then(() => {
        const parentElement = evt.target.closest(".copy-wrapper");
        const tooltip = parentElement.querySelector(".tooltip");

        if (tooltip) {
          tooltip.classList.add("show");

          setTimeout(() => {
            tooltip.classList.remove("show");
          }, 2000);
        }
      })
      .catch((err) => {
        console.error("Error: ", err);
      });
  }

  const mainArticle = () => {
    if (document.querySelector(".rte blockquote")) {
      document.querySelectorAll(".rte blockquote").forEach((blockquote) => {
        let prev = blockquote.previousElementSibling;
        prev.style.marginBottom = "0";
      });
    }

    const content = document.querySelector(".article-template__content");
    const progressBar = document.querySelector(".progress-bar");
    const header = document.querySelector(".article-template__content--header");

    function updateProgressBar() {
      if (!content || !progressBar || !header) return;

      const rect = content.getBoundingClientRect();

      const contentTop = rect.top + window.scrollY;
      const contentHeight = rect.height;

      const start = contentTop;

      const originalEnd =
        contentTop + contentHeight - header.clientHeight - 114;

      const maxScrollable =
        document.documentElement.scrollHeight - window.innerHeight;

      const effectiveEnd = Math.min(originalEnd, maxScrollable);

      const currentScroll = window.scrollY;

      let progress = ((currentScroll - start) / (effectiveEnd - start)) * 100;

      progress = Math.min(Math.max(progress, 0), 100);

      progressBar.style.width = `${(progress / 100) * 101}%`;

      let originalProgress =
        ((currentScroll - start) / (originalEnd - start)) * 100;

      originalProgress = Math.min(Math.max(originalProgress, 0), 100);

      const visibleBar = originalProgress > 0 && originalProgress < 100;

      header.classList[visibleBar ? "add" : "remove"]("active");
    }

    window.addEventListener("scroll", () => updateProgressBar(true));
    window.addEventListener("resize", updateProgressBar);

    updateProgressBar();
  };

  document.addEventListener("DOMContentLoaded", () => {
    const copyLinks = document.querySelectorAll(".copy-btn");

    mainArticle();

    for (const copyLink of copyLinks) {
      copyLink.addEventListener("click", copyURI);
    }
  });

  document.addEventListener("shopify:section:load", function () {
    mainArticle();
  });

  document.addEventListener("shopify:section:select", function () {
    mainArticle();
  });

  document.addEventListener("shopify:block:change", () => {
    mainArticle();
  });

  document.addEventListener("shopify:section:change", () => {
    mainArticle();
  });
})();
